import React from 'react';
import VSL from '../components/VSL';
import WebinarContent from '../components/WebinarContent';
import Testimonials from '../components/Testimonials';

const Home = ({ onOpenModal }) => {
  return (
    <>
      <VSL onOpenModal={onOpenModal} />
      <WebinarContent onOpenModal={onOpenModal} />
      <Testimonials onOpenModal={onOpenModal} />
    </>
  );
};

export default Home;